import React from 'react';
import { colors } from 'helpers/ColorHelper.js';
import { formatPhone } from 'helpers/Formatter';

const AdditionalOccupants = props => {
  const headerClass = {
    backgroundColor: colors.BODY_GRAY,
    margin: '20px -15px',
    textAlign: 'center',
    color: 'rgb(136, 136, 136)',
  };
  const infoClass = {
    color: colors.ICON_GRAY,
    textAlign: 'justify',
    fontWeight: 700,
    fontFamily: 'Circular-Bold',
  };
  const noOccupantsClass = {
    textAlign: 'center',
    fontSize: '85%',
  };
  const { additionalOccupants } = props;
  return (
    <div>
      <div className="row" style={headerClass}>
        <h5>Additional Occupants</h5>
      </div>
      <div className="row">
        {additionalOccupants && additionalOccupants.length > 0 ? (
          additionalOccupants.map((cotenant, index) => (
            <div className="col-sm-6" key={`ao_${index}`} style={{ marginBottom: '15px' }}>
              <h4 style={{ margin: 0, marginBottom: '5px' }}>{cotenant.full_name}</h4>
              <div style={infoClass}>{cotenant.relationship}</div>
              <div style={infoClass}>{cotenant.birthday}</div>
              {cotenant.email && <div style={infoClass}>{cotenant.email}</div>}
              {cotenant.phone_number && (
                <div style={infoClass}>{formatPhone(cotenant.phone_number)}</div>
              )}
            </div>
          ))
        ) : (
          <div style={noOccupantsClass}>No Additional Occupants</div>
        )}
      </div>
    </div>
  );
};

export default AdditionalOccupants;
